import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import {GlobalConstants} from 'src/app/global-constants'
import { UtilitiesService } from 'src/app/shared/utilities.service';

@Component({
  selector: 'selection-notification-modal',
  templateUrl: './notification-modal.component.html'
})
export class NotificationModalComponent implements OnInit {

  @Input() selection: any;

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    public utilitiesService : UtilitiesService
  ) { }

  ngOnInit() {}

  @ViewChild('notificationsModal', { static: true }) notificationsModal: any;
  ngOnChanges() {
    if (this.selection && this.selection.id) {
      this.error = {};
      this.notifications = [];
      this.notificationsModal.show();
      this.getNotifications();
    }
  }

  notificationsLoading: boolean = false
  notifications: any = [];
  error: any = {};
  getNotifications() {
    let url = this.appConstants.endPoints.notificationEndPoint + 'query-notifications';
    this.notificationsLoading = true;
    this.service.post(url, {}, {
      "pageNumber": 1,
      "pageSize": 300,
      "isPaging": true,
      "referenceId": this.selection.id
    })
      .pipe(finalize(() => {
        this.notificationsLoading = false
      }))
      .subscribe(data => {
        let notifications = data && data.searchResults ? data.searchResults: [];
        this.notifications = notifications.map(res => { res['isOpen'] = false; res['isLoading'] = false; res['attachMents'] = []; return res })
      }, res => {
        this.errorService.errorHandling(res).then(res => {
          this.error = res;
        });
      })
  }
  destinations: any = [];
  getNotificationDestinations(notification) {
    if (notification.isOpen) {
      this.notifications.forEach(res => {
        if (res.id != notification.id)
          res.isOpen = false
      })
      this.destinations = [];
      notification.isLoading = true;
      let url = this.appConstants.endPoints.notificationEndPoint + notification.id + '/destinations';
      this.service.get(url, {})
        .pipe(finalize(() => {
          notification.isLoading = false;
        }))
        .subscribe(data => {
          if (data)
            this.destinations = data ? data : []
        }, res => {
          this.errorService.errorHandling(res).then(res => {
            this.error = res;
          });
        })
    }
  }

  documentPagingInfo = {
    pageSize: 10,
    pageNumber: 1,
    totalRows: 0
  }


  documentIds: any = []
  documentListInfo(notification) {
    let url = this.appConstants.endPoints.notificationEndPoint + notification.id + '/attachments';
    this.service.get(url, {})
      .pipe(finalize(() => {

      }))
      .subscribe(data => {
        let documentIds = data ? data : []
        this.documentIds = documentIds.map(element => {
          return element.id;
        });
        this.documentIds && this.documentIds.length ? this.getNotificationDocuments(notification) : notification.attachMents = [];

      }, res => {
        this.errorService.errorHandling(res).then(res => {
          this.error = res;
        });
      })

  }

  getNotificationDocuments(notification) {
    this.service
      .post(this.appConstants.endPoints.sprigEndPoint + 'documents/' + GlobalConstants.scheduleApplicationID + '/query-documents', {}, {
        isPaging: false,
        documentIds: this.documentIds
      })
      .pipe(finalize(() => {

      })).subscribe(data => {
          this.documentPagingInfo.totalRows = data && data.pagingInfo ? data.pagingInfo.totalRows : 0;
          let documents = data && data.searchResults ? data.searchResults : [];
          documents.forEach(doc => {
            doc.disabled = doc.fileSize ? false : true
          });
          notification.attachMents = documents ? documents : [];
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
  }
}